import React from 'react'
import Kategori_FaskesService from '../Service/kategori_faskesService'
import FormInput from './formInput'
import './kategori_faskes.css'
import ModalHapus from './modalHapus'
import ModalSave from './modalSave'
import ModalDelete from './modalDelete'
import { config } from '../Config/config'

export default class index extends React.Component {
    user = localStorage.getItem(config.userid)
    kategori_faskesModel = {
        NAMA: "",
        created_by : this.user,
        modified_by : this.user,
        delete_by : this.user,
        dibuat_oleh : localStorage.getItem(config.username)
    }

    constructor() {
        super()
        this.state = {
            List: [],
            username: localStorage.getItem(config.username),
            Model: this.kategori_faskesModel,
            errors: {},
            Mode: "TAMBAH",
            showModalDel: false,
            showModalDelete: false,
            showModalSave: false,
            filter: {
                search: "",
                dibuat_oleh : localStorage.getItem(config.userid)
            }
        }
    }

    loadList = async () => {
        const respon = await Kategori_FaskesService.getAllFilter(this.state.filter)
        console.log(respon)
        if (respon.success) {
            this.setState({
                List: respon.result
            })
        }
        console.log(this.state.List)
    }

    componentDidMount() {
        this.loadList()
        console.log(this.state.Model)
    }

    //untuk filter
    filterHandler = field => ({ target: { value } }) => {
        this.setState({
            filter: {
                ...this.state.filter,
                [field]: value
            }
        })
    }

    //untuk merubah nama dan description di form input
    changeHandler = name => ({ target: { value } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                [name]: value
            }
        })
    }

    //untuk button submit
    saveHandler = async () => {
        const responNama = await Kategori_FaskesService.getByNama(this.state.Model.NAMA)
        var name = ""
        if(responNama.result != undefined){
            name = responNama.result.NAMA
        }

        if (this.handleValidation(name)) {
            if (this.state.Mode == "UBAH") {
                this.setState({
                    Model:{
                        ...this.state.Model,
                        ['modified_by']: this.user
                    }
                },async ()=>{const respon = await Kategori_FaskesService.EditData(this.state.Model)
                    if (respon.success) {
                        // alert("Success Update Data")
                        this.loadList()
                        this.setState({
                            Model: this.kategori_faskesModel,
                            showModal: false,
                            showModalSave: true
                        })
                    }})
                
            }
            else {
                const respon = await Kategori_FaskesService.addData(this.state.Model)
                if (respon.success) {
                    // alert("Succes Save Data")
                    this.loadList()
                    this.setState({
                        Model: this.kategori_faskesModel,
                        showModal: false,
                        showModalSave: true
                    })
                }
            }
        } else {
            // alert("Form has errors.")
        }
    }

    //untuk button edit
    editHandler = async (id) => {
        const respon = await Kategori_FaskesService.getById(id)
        console.log(respon)

        this.setState({
            Mode: ""
        })

        if (respon.success) {
            this.setState({
                Model: respon.result
            })
        }
    }

    //button awal delete
    deleteHandler = async (id) => {
        const respon = await Kategori_FaskesService.getById(id)

        this.setState({
            showModalDel: true
        })
        if (respon.success) {
            this.setState({
                Model: respon.result
            })
        }

    }

    //button modal yakin delete
    deleteHandler2 = async () => {
        let tmpID = { _id: this.state.Model._id, delete_by : this.user }
        const respon = await Kategori_FaskesService.DeleteData(tmpID)

        if (respon.success) {

            this.loadList()
            this.setState({
                showModalDel: false,
                showModalDelete: true
            })
        }
    }

    //untuk modal
    editHandler = async (id) => {
        const respon = await Kategori_FaskesService.getById(id)
        this.setState({
            Mode: "UBAH",
            showModal: true
        })
        if (respon.success) {
            this.setState({
                Model: respon.result
            })
        }
    }

    createHandler = () => {
        this.setState({
            Mode: "TAMBAH",
            showModal: true,
            Model: this.kategori_faskesModel
        })
        console.log(this.state.showModal)
    }

    cancelHandler = () => {
        this.setState({
            Mode: "",
            showModal: false,
            showModalDel: false,
            showModalSave: false,
            showModalDelete: false
        })
    }



    // untuk validasi
    handleValidation(cekNama) {
        let fields = this.state.Model
        let errors = {};
        let formIsValid = true;

        //Name
        if (!fields["NAMA"]) {
            formIsValid = false;
            errors["NAMA_1"] = "Cannot be empty";
        }

        //NAMA sudah ada
        else if (cekNama) {
            formIsValid = false;
            errors["NAMA_2"] = "NAMA already taken";
        }


        this.setState({ errors: errors });
        return formIsValid;
    }


    render() {
        const { List, errors, Mode } = this.state
        return (
            <div class="container">
                <div class="text-center">
                    <h1>Kategori Fasilitas Kesehatan</h1>
                </div>
                <br /> <br />

                <button type="button" class="btn btn-primary float-right " onClick={this.createHandler}> <i class="fa fa-plus"></i> Tambah</button>

                <div class="input-group col-5 mb-1 float-left">
                    <input class="form-control rounded-left" type="text" placeholder="Cari Berdasarkan Nama" onChange={this.filterHandler("search")}/>
                    <div class="input-group-append"onClick={this.loadList}>
                        <button class="btn btn-primary rounded-right" type="button">
                            <i class="fa fa-search"></i>
                        </button>
                    </div>
                </div>
                



                {/* {JSON.stringify(this.state.Model)} */}
                <br /> <br /> <br />
                <table class="table table-striped">
                    <thead>
                        <tr class="bg-primary text-center">
                            <th scope="col">NAMA</th>
                            <th scope="col">Dibuat Oleh</th>
                            <th scope="col">#</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            List.map(data => {
                                return (
                                    <tr class="text-center">
                                        <td>{data.nama_faskes}</td>
                                        <td>{data.dibuat_oleh}</td>
                                        <td>
                                            <button class="btn btn-primary mr-2" onClick={() => this.editHandler(data._id)}>Edit</button>
                                            <button class="btn btn-danger" onClick={() => this.deleteHandler(data._id)}>Delete</button>
                                        </td>
                                    </tr>

                                )
                            })
                        }
                    </tbody>
                </table>
                <FormInput changeHandler={this.changeHandler}
                    checkedHandler={this.checkedHandler}
                    saveHandler={this.saveHandler}
                    Model={this.state.Model}
                    CreateHandler={this.createHandler}
                    ShowModal={this.state.showModal}
                    EditHandler={this.editHandler}
                    CancelHandler={this.cancelHandler}
                    errors={errors}
                    Mode={Mode}
                />
                <ModalHapus changeHandler={this.changeHandler}
                    saveHandler={this.saveHandler}
                    CreateHandler={this.createHandler}
                    ShowModalDel={this.state.showModalDel}
                    CancelHandler={this.cancelHandler}
                    DeleteHandler2={this.deleteHandler2}
                    List={List}
                    Model={this.state.Model}
                />
                <ModalSave changeHandler={this.changeHandler}
                    // saveHandler={this.saveHandler}
                    // CreateHandler={this.createHandler}
                    ShowModalSave={this.state.showModalSave}
                    CancelHandler={this.cancelHandler}
                    // DeleteHandler2={this.deleteHandler2}
                    // List={List}
                    Model={this.state.Model}
                    Mode={Mode}
                />
                <ModalDelete changeHandler={this.changeHandler}
                    // saveHandler={this.saveHandler}
                    // CreateHandler={this.createHandler}
                    ShowModalDelete={this.state.showModalDelete}
                    CancelHandler={this.cancelHandler}
                    // DeleteHandler2={this.deleteHandler2}
                    // List={List}
                    Model={this.state.Model}
                    Mode={Mode}
                />

            </div>
        )
    }
}